import * as React from 'react'

import { Modal } from '@lmc/ui-kit'

import { useTranslation } from 'react-i18next'
import { CSSProperties, ReactNode } from 'react'
import colors from '@lmc/common/constants'

type DeleteSkillNeedModalProps = {
  onConfirm: () => void
  handleToogleDeleteModal: () => void
  isModalVisible: boolean
  children: ReactNode
  title: string
}

export const DeleteSkillNeedModal = ({
  onConfirm,
  handleToogleDeleteModal,
  isModalVisible,
  children,
  title,
}: DeleteSkillNeedModalProps): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal
      localisation={{
        title,
        confirmText: t(`skillsAndNeeds.yesDelete`),
        cancelText: t(`general.buttons.cancel`),
      }}
      onConfirm={onConfirm}
      onCancel={handleToogleDeleteModal}
      isModalVisible={isModalVisible || false}
      closeButton
      closeOnConfirm={false}
      noPadding
      confirmButtonProps={{ type: 'danger' }}
    >
      <div style={styles.container as CSSProperties}> {children}</div>
    </Modal>
  )
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid',
    borderColor: colors.grey,
    paddingBottom: 15,
  },
}

export default DeleteSkillNeedModal
